import { gql } from '@apollo/client'

import { FRAGMENT_COMPANY } from '../fragments/company'
import { FRAGMENT_COMPANY_PLAN } from '../fragments/companyPlan'
import { FRAGMENT_PLAN } from '../fragments/plan'
import { FRAGMENT_WORKSPACE } from '../fragments/workspace'

export const GET_WORKSPACE_COMPANY_PLAN = gql`
  query getWorkspaceCompanyPlan {
    getWorkspace {
      ...FragmentWorkspace
      company {
        ...FragmentCompany
        companyPlan {
          ...FragmentCompanyPlan
        }
        plan {
          ...FragmentPlan
        }
      }
    }
  }
  ${FRAGMENT_WORKSPACE}
  ${FRAGMENT_COMPANY}
  ${FRAGMENT_COMPANY_PLAN}
  ${FRAGMENT_PLAN}
`
